export enum Target {
  Blank = '_blank',
  Self = '_self',
}
